const domains = {
	"prod.fe.cam-loy-storck-nimm-2-der-sommer-lacht-2026-frontend.campaign-loyalty.com": {
		apibase: "/",
	},
}
export const getEnvConfig = () => {
	return domains[window.location.host] || { apibase: "/inte/" }
}
